import {get, post} from '../index'
export default {
  // 获取活动分类列表
  getActivityClassifyList (querys) {
    return get('/activity/admin/activityClassifyAdmin/listAll', querys)
  },
  // 添加活动分类详情
  addActivityClassifyInfo (querys) {
    return post('/activity/admin/activityClassifyAdmin/createActivityClassify', querys)
  },
  // 编辑活动分类详情
  editActivityClassifyInfo (querys) {
    return post('/activity/admin/activityClassifyAdmin/updateActivityClassify', querys)
  },
  // 上下架、删除活动分类信息
  updateActivityClassifyInfo (querys) {
    return post('/activity/admin/activityClassifyAdmin/changeStatus', querys)
  },
  // 删除活动分类信息
  delActivityClassify (querys) {
    return post('/activity/admin/activityClassifyAdmin/changeStatus', querys)
  },
  // 报名内容列表
  getActivityContentList (querys) {
    return get('/activity/admin/activityItemAdmin/listAllWithPage', querys)
  },
  // 添加报名内容
  addActivityContentInfo (querys) {
    return post('/activity/admin/activityItemAdmin/createOne', querys)
  },
  // 编辑报名内容
  editActivityContentInfo (querys) {
    return post('/activity/admin/activityItemAdmin/updateOne', querys)
  },
  // 上下架报名内容
  updateActivityContentInfo (querys) {
    return post('/activity/admin/activityItemAdmin/changeStatus', querys)
  },
  // 活动管理列表
  getActivityManageList (querys) {
    return get('/activity/admin/activityAdmin/listAll', querys)
  },
  // 添加活动信息
  addActivityInfo (querys) {
    return post('/activity/admin/activityAdmin/createOne', querys)
  },
  // 编辑活动信息
  editActivityInfo (querys) {
    return post('/activity/admin/activityAdmin/updateOne', querys)
  },
  updateActivityInfo (querys) {
    return post('/activity/admin/activityAdmin/changeStatus', querys)
  },
  // 活动信息回显
  getActivityInfo (querys) {
    return get('/activity/admin/activityAdmin/getOne', querys)
  },
  // 获取活动编辑页面下拉分类
  getActivityListAllForSelect () {
    return get('/activity/admin/activityClassifyAdmin/listAllForSelect')
  },
  // 获取活动报名及页面下拉的报名内容
  getActivityAllNoPage () {
    return get('/activity/admin/activityItemAdmin/getAllNoPage')
  },
  // 获取报名情况列表表头
  getActivitySignUpHeader (querys) {
    return get('/activity/admin/activityUserRecordAdmin/getTableHead', querys)
  },
  // 获取报名情况列表数据
  getActivitySignUpList (querys) {
    return get('/activity/admin/activityUserRecordAdmin/listByActivity', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/activity.js